import React from "react"
import PropTypes from "prop-types"
import {withRouter} from "react-router-dom"

import id from "@irati/utils/id"
import {H4} from "@irati/ui/src/Headings"
import {Row, Col} from "react-bootstrap"
import {injectRouteWithQuery} from "@irati/utils/helpers/routing"
import {groupQuestionsByDriver} from "@irati/insights/helpers/question"
import {AnalysisContext} from "@irati/insights/context"
import {injectIntl} from "@irati/utils/lang"

import DriverScoreRouterLink from "./DriverScoreRouterLink"
import helper from "../../helpers/AverageScorePerDriver"
import sitemap from "../../routes/sitemap"

const DriverSummaryScore = ({questions, match, drivers, formatMessage, ...props}) => {
  const idNamespace = id("DriverSummaryScore", props)
  const questionsByDriver = groupQuestionsByDriver(questions, drivers, true)

  return (
    <AnalysisContext.Consumer>
      {({filters}) => (
        <Row>
          <Col md={12}>
            <H4 base>{formatMessage({id: "insights.analysis.driverSummaryScore.heading"})}</H4>
            {helper.descendingOrderDriverScores(questionsByDriver).map((driver) => (
              <DriverScoreRouterLink
                id={idNamespace}
                to={injectRouteWithQuery(sitemap.analysis.url, {
                  params: {...match.params},
                  queryParams: {
                    ...filters,
                    driverId: driver.driverId
                  }
                })}
                key={driver.driverId}
                driver={driver} />
            ))}
          </Col>
        </Row>
      )}
    </AnalysisContext.Consumer>
  )
}

DriverSummaryScore.propTypes = {
  questions: PropTypes.array,
  drivers: PropTypes.array,
  formatMessage: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.object
  }).isRequired
}
DriverSummaryScore.defaultProps = {
  questions: [],
  drivers: {}
}

export default injectIntl(withRouter(DriverSummaryScore))
